/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { SagaIterator } from 'redux-saga';
import { call, select } from 'redux-saga/effects';
import {
  Channel,
  FileFormat,
  WatchOption,
  Vod,
  Stream,
  WatchOptionVod,
  AssetOptionType,
  WatchOptionType,
  Asset,
  ContentTagsUtils,
  AssetUtils,
} from '@wit/vtv-x-foundation-lib';
import { Selectors as PlayableChannelsSelectors } from '../../epg/playableChannels';

function buildTrailerOption(asset: Vod, stream: Stream, channels: Channel[]): WatchOptionVod {
  return {
    key: `${AssetOptionType.WATCH}-${WatchOptionType.VOD}-${asset.id}-${stream.id}`, // trailer stream
    type: AssetOptionType.WATCH,
    title: '', // set in the UI
    asset,
    label: '',
    watchOptionType: WatchOptionType.VOD,
    stream,
    channel: AssetUtils.getAssetRelatedChannel(asset, channels),
  };
}

function getTrailerOptions(clones: Asset[], channels: Channel[]): WatchOption[] {
  const options: WatchOptionVod[] = [];

  clones.forEach((clone) => {
    if (AssetUtils.isVod(clone) && ContentTagsUtils.isPlaybackAllowedForVodAsset(clone)) {
      clone.streams.forEach((stream) => {
        if (stream.fileFormat === FileFormat.TRAILER) {
          options.push(buildTrailerOption(clone as Vod, stream, channels));
        }
      });
    }
  });

  return options;
}

function* getOptions(clones: Asset[]): SagaIterator<WatchOption[]> {
  const channels: Channel[] = yield select(PlayableChannelsSelectors.getChannels) || [];

  const result = yield call(getTrailerOptions, clones, channels);

  return result;
}

export default {
  getOptions,
};
